import {createReducer} from 'redux-act'

import * as actions from '#app/store/actions/jobs'

export interface JobsState {
  [jobId: string]: { percent: number };
}

const jobs: JobsState = {
};

const handleCreateJob = (state: JobsState, id: string | number): JobsState => {

  if(typeof id === 'string' || typeof id === 'number')
  {
    state[id] = {percent: 0};

    return state
  }else{
    return state;
  }
}

const handleUpdateJob = (state: JobsState, id: string | number, percent?: unknown): JobsState => {

  if(typeof id === 'string' || typeof id === 'number')
  {
    state[id] = {percent: percent as number};

    return state
  }else{
    return state;
  }
}

const handleRemoveJob = (state: JobsState, id: string | number): JobsState => {

  if(typeof id === 'string' || typeof id === 'number')
  {
    delete state[id];

    return state
  }else{
    return state;
  }
}


const reducer = createReducer<JobsState>((on) => {
  on(actions.handleCreateJob, handleCreateJob);
  on(actions.handleUpdateJob, handleUpdateJob);
  on(actions.handleRemoveJob, handleRemoveJob);
}, jobs)

export default reducer
